import { Button, Stack, Tooltip, tooltipClasses } from '@mui/material'
import { styled } from '@mui/material/styles'
import { grey } from '@mui/material/colors'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Body2 } from 'components/styledFonts'


export const help1 = `\
メディアが具体的な取材を前向きに検討している状態です。
今後は、取材日程の調整や詳細確認など、記事化に向けた具体的なやり取りへ進みます。
※最終的な掲載を保証するものではありませんが、取材実施の可能性が高いフェーズです。
`

export const help2 = `\
エントリー内容に関心を持ち、まずは情報交換・ヒアリングを行いたいとメディアが判断した状態です。
すぐに取材を前提とするものではありませんが、今後の企画検討や関係構築につながる重要なフェーズです。

この段階では、
・スピーディーな日程調整
・メディアが求める情報を的確に準備すること
が非常に重要になります。

初回の打ち合わせでは「どのような情報があれば取材検討につながるか」を確認しながら、丁寧な対応と継続的なコミュニケーションが、次の段階の「取材」に進む鍵となります。
`

export const help3 = `\
今回のエントリー内容が、メディアの企画意図や募集テーマと一致しなかった状態です。
企業や情報の価値が否定されたものではなく、タイミングや企画内容との相性による結果となります。
内容の切り口や伝え方を再設計し、再エントリーすることで、次回マッチングにつながる可能性があります。
`


export const StatusTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 800,
        color: grey[700],
        background: grey[50],
        boxShadow: theme.shadows[10],
        border: `1px solid ${grey[500]}`,
        marginLeft: 8,
        padding: 12,
    }
}))

export const Help = ({ title, text }) => (
    <Stack>
        <Body2>{title}</Body2>
        <Body2
            sx={{ pl:1.5, whiteSpace: "pre-wrap" }}
        >
            {text}
        </Body2>
    </Stack>
)

export const StatusHelp = () => (
    <StatusTooltip
        placement="bottom-start"
        title={
            <Stack
                sx={{ rowGap: 0.5 }}
            >
                <Body2>＜ステータスのマッチング結果表記について＞</Body2>
                <Stack
                    sx={{ rowGap: 2 }}
                >
                    <Help
                        title="■マッチング成立"
                        text={help1}
                    />
                    <Help
                        title="■情報交換マッチング成立"
                        text={help2}
                    />
                    <Help
                        title="■マッチング不成立"
                        text={help3}
                    />
                </Stack>
            </Stack>
        }
    >
        <Button
            sx={{ py: 0 }}
            startIcon={<HelpOutlineOutlinedIcon />}
        >
            ステータスのマッチング結果表記について
        </Button>
    </StatusTooltip>
)
